import type { Theme, ThemeKeys } from "./types";
import { DEFAULT_THEME } from "@softr-io/design-system/default-theme";
import { get } from "./utils";

export const generateThemeKeys = <T extends Theme>(theme: T, prefix?: string): ThemeKeys<T> => {
    const themeKeys: Record<string, unknown> = {};

    for (const key of Object.keys(theme)) {
        const value = theme[key];
        if (typeof value === "object") {
            themeKeys[key] = generateThemeKeys(value, prefix ? `${prefix}.${key}` : key);
        } else {
            themeKeys[key] = { themeKey: prefix ? `${prefix}.${key}` : key };
        }
    }

    return themeKeys as ThemeKeys<T>;
};

export const themeKeys = generateThemeKeys(DEFAULT_THEME);

export const getThemeTokenByPath = (theme: Theme, path: string) => {
    return get(theme, path);
};

// re-exporting from design system for studio needs
export { createTheme } from "@softr-io/design-system/theme";
